<template>
  <div :class="$style.field">
    <button
      v-if="crmName === 'Salesforce'"
      @click="submit"
      :class="[$style.button, $style.salesforceButton]"
      :disabled="busy"
    >
      <font-awesome-icon :icon="faSalesforce" />{{ buttonText }}
    </button>
    <button
      v-else-if="crmName === 'HubSpot'"
      @click="submit"
      :class="[$style.button, $style.hubspotButton]"
      :disabled="busy"
    >
      <img :src="hubspotLogoUrl" alt="" />{{ buttonText }}
    </button>
    <button
      v-else-if="crmName === 'Pipedrive'"
      @click="submit"
      :class="[$style.button, $style.pipedriveButton]"
      :disabled="busy"
    >
      <img :src="pipedriveLogoUrl" alt="" />{{ buttonText }}
    </button>
    <button
      v-else-if="crmName === 'Copper'"
      @click="submit"
      :class="[$style.button, $style.copperButton]"
      :disabled="busy"
    >
      <img :src="copperLogoUrl" alt="" />{{ buttonText }}
    </button>
    <button
      v-else-if="crmName === 'Close'"
      @click="submit"
      :class="[$style.button, $style.closeButton]"
      :disabled="busy"
    >
      <img :src="closeLogoUrl" alt="" />{{ buttonText }}
    </button>
    <button
      v-else-if="crmName === 'Bullhorn'"
      @click="submit"
      :class="[$style.button, $style.bullhornButton]"
      :disabled="busy"
    >
      <img :src="bullhornLogoUrl" alt="" />{{ buttonText }}
    </button>
    <button v-else @click="submit" :class="$style.button" :disabled="busy">
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
import axios from "axios";
import { createNamespacedHelpers } from "vuex";
import { errorNotification } from "../notifications";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faSalesforce } from "@fortawesome/free-brands-svg-icons/faSalesforce";

const { mapState, mapMutations } = createNamespacedHelpers("activitySummary");

export default {
  components: {
    FontAwesomeIcon,
  },
  props: {
    loggingToCrm: Boolean,
  },
  data() {
    return {
      faSalesforce,
      busy: false,
      team: this.$_activitySummary_config.getTeam(),
      hubspotLogoUrl: this.$_activitySummary_config.hubspotLogoUrl,
      pipedriveLogoUrl: this.$_activitySummary_config.pipedriveLogoUrl,
      copperLogoUrl: this.$_activitySummary_config.copperLogoUrl,
      closeLogoUrl: this.$_activitySummary_config.closeLogoUrl,
      bullhornLogoUrl: this.$_activitySummary_config.bullhornLogoUrl,
    };
  },
  computed: {
    ...mapState([
      "activity",
      "layoutId",
      "formValues",
      "formErrors",
      "fieldValues",
      "fieldErrors",
    ]),
    crmName() {
      return this.team.crm.name;
    },
    buttonText() {
      let idleText = "Save";
      let busyText = "Saving...";

      if (this.loggingToCrm) {
        idleText = `Log to ${this.crmName}`;
        busyText = "Logging...";
      }

      return this.busy ? busyText : idleText;
    },
  },
  methods: {
    ...mapMutations(["upsertFormData", "upsertFieldData", "setPristineFlag"]),
    submit() {
      this.$_activitySummary_config.EventBus.$emit("ACTIVITY_FORM_SUBMITTED");

      if (this.hasErrors()) {
        return;
      }

      const params = {
        layout_id: this.layoutId,
        ...this.discardEmpty(this.formValues),
        entities: this.discardEmpty(this.fieldValues),
      };

      this.busy = true;

      axios
        .post(
          `${this.$_activitySummary_config.jiminnyHost()}/api/v1/activity/${
            this.activity.id
          }/summarize`,
          params
        )
        .then(() => {
          this.$emit("success");
          this.busy = false;
          this.setPristineFlag(true);
        })
        .catch((error) => {
          this.busy = false;

          if (!error.response) {
            console.error(error);
            return;
          }

          if (error.response.status === 422) {
            for (const [id, errors] of Object.entries(
              error.response.data.errors
            )) {
              if (id.startsWith("entities.")) {
                const realId = id.split("entities.")[1];
                this.upsertFieldData({ id: realId, error: errors[0] });
              } else {
                this.upsertFormData({ id, error: errors[0] });
              }
            }
          } else if (error.response.status === 400) {
            errorNotification({
              message: error.response.data.error.message,
            }).show();
          } else {
            errorNotification({
              message:
                "Sorry, your activity could not be logged due to an internal error. Please try again later.",
            }).show();
          }
        });
    },
    hasErrors() {
      return Object.values({
        ...this.formErrors,
        ...this.fieldErrors,
      }).some((error) => !!error);
    },
    discardEmpty(object) {
      const obj = {};
      for (const [key, value] of Object.entries(object)) {
        if (value || typeof value === "boolean") {
          obj[key] = value;
        }
      }
      return obj;
    },
  },
};
</script>

<style module lang="less" src="./submit-button.less"></style>



// WEBPACK FOOTER //
// submit-button.vue?2848e8c2